export const styleSheet = () => ({
  pageRoot: {
    marginTop: "100px",
  },
  docsTitle: {
    display: "flex !important",
    alignItems: "center  !important",
    fontSize: "16px !important",
    fontWeight: "500 !important",
    fontFamily: "AvenirNext  !important",
    color: "rgba(0, 0, 0, 0.87)",
    "& svg": {
      marginRight: "10px",
    },
  },
  newfolderButton: {
    display: "flex !important",
    alignItems: "center !important",
    fontWeight: "400 !important",
    fontSize: "13px !important",
    textTransform: "capitalize !important",
    backgroundColor: "#0B0909  !important",
    color: "white",
    borderRadius: "25px !important",
    padding: "5px 15px !important",
  },
  docsAppBar: {
    justifyContent: "flex-end",
    alignItems: "center",
    height: "53px",
    backgroundColor: "#fff !important",
  },
  subHeaderArea: {
    justifyContent: "flex-end",
    alignItems: "center",
    height: "53px",
    marginBottom: "30px",
    backgroundColor: "#fff !important",
  },
  docsAppBarArea: {
    display: "flex",
    height: "53px",
    justifyContent: "space-between",
    alignItems: "center",
  },
  docsAppBarRight: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "12px",
  },
  customAppbarButton: {
    marginLeft: "15px !important",
  },
  customAppbarButtonText: {
    fontSize: "12px",
    color: "rgba(0, 0, 0, 0.87)",
    marginTop: "-5px",
  },
});
